import { Tabs, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

import { AccessDetails, CommonDetails } from './components';
import { InvoiceDetails } from './components/InvoiceDetails';

enum TabValue {
  COMMON = 'common',
  ACCESS = 'access',
  INVOICE_DATA = 'invoiceData',
}

export const AccountDetails = () => {
  const theme = useMantineTheme();
  const isDesktop = useMediaQuery(`(min-width: ${theme.breakpoints.md}px)`);

  return (
    <Tabs color="dark" variant="default" defaultValue="common">
      <Tabs.List
        style={{
          flexWrap: isDesktop ? 'nowrap' : 'wrap',
          rowGap: isDesktop ? 0 : 8,
        }}
      >
        <Tabs.Tab value={TabValue.COMMON}>Dados gerais</Tabs.Tab>
        <Tabs.Tab value={TabValue.ACCESS}>Dados de acesso</Tabs.Tab>
        <Tabs.Tab value={TabValue.INVOICE_DATA}>Dados de faturação</Tabs.Tab>
      </Tabs.List>

      <Tabs.Panel value={TabValue.COMMON} pl={isDesktop ? 'xl' : 0}>
        <CommonDetails />
      </Tabs.Panel>

      <Tabs.Panel value={TabValue.ACCESS} pl={isDesktop ? 'xl' : 0}>
        <AccessDetails />
      </Tabs.Panel>

      <Tabs.Panel value={TabValue.INVOICE_DATA} pl={isDesktop ? 'xl' : 0}>
        <InvoiceDetails />
      </Tabs.Panel>
    </Tabs>
  );
};
